// @flow
// @flow-runtime warn
import { createContext } from 'react';

import { type OrderFromList } from './OrdersTypes';


type ContentType = {
  orders: Array<OrderFromList>,
  count: number,
}

const defaultContent: ContentType = {
  orders: [],
  count: 0,
};

type LoadingType = {
  orders: boolean,
}

const defaultLoading: LoadingType = {
  orders: true,
};

type RequestsType = {
  orders: (append?: boolean, offset?: number, limit?: number) => Promise<boolean> | boolean,
  ordersNext: () => Promise<boolean> | boolean,
}

const defaultRequests = {
  orders: () => false,
  ordersNext: () => false,
};

type OrdersContextType = {
  content: ContentType,
  loading: LoadingType,
  request: RequestsType,
}

const defaultContext: OrdersContextType = {
  content: defaultContent,
  loading: defaultLoading,
  request: defaultRequests,
};

export default createContext<OrdersContextType>(defaultContext);
